import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import CloseIcon from '@material-ui/icons/Close';
import Rating from '@material-ui/lab/Rating';
import { useSnackbar } from 'notistack';

import { TextInput, TagsInput } from '../../../Components';
import { createAPI, updateAPI, getListAllAPI } from '../../../services';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    // color: theme.palette.grey[500],
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const DEFAULT_ID = -1;

const DialogoCategoriaTransacao = forwardRef(({ handleClose }, ref) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [pergunta, setPergunta] = useState('');
  const [resposta, setResposta] = useState('');
  const [categorias, setCategorias] = useState([]);
  const [categoriasOptions, setCategoriasOptions] = useState([]);
  const [id, setId] = useState(DEFAULT_ID);

  const [carregando, setCarregando] = useState(false);

  const classes = useStyles({ cor: '#009FD4' });

  const handleCloseDialog = () => {
    setOpen(false);
    handleClose();
  };

  async function reiniciar() {
    setId(DEFAULT_ID);
    setPergunta('');
    setResposta('');
    setCategorias([]);
    setCarregando(false);
  }

  useEffect(() => {
    async function getDadosLocais() {
      try {
        const data = await getListAllAPI(
          'categorias_perguntas',
          ['id', 'asc'],
          {},
          [],
        );
        setCategoriasOptions(data.data);
      } catch (erros) {
        enqueueSnackbar(`${erros}`, {
          variant: 'error',
        });
        handleCloseDialog();
      }
    }
    if (open) getDadosLocais();
  }, [open]);

  async function getDataResource(id) {
    try {
      const data = await getListAllAPI(
        'perguntas',
        ['id', 'asc'],
        { id: [id] },
        ['categorias'],
      );
      if (data.data.length > 0) {
        setId(data.data[0].id);
        setPergunta(data.data[0].pergunta);
        setResposta(data.data[0].resposta);
        setCategorias(data.data[0].categorias);
        setCarregando(false);
      } else {
        throw 'Esta categoria de pergunta não existe!';
      }
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  function getIdsOptions() {
    const ids = [];
    for (let i = 0; i < categorias.length; i += 1) {
      ids.push(categorias[i].id);
    }
    return ids;
  }

  async function handleSalvar() {
    setCarregando(true);
    try {
      if (id <= 0) {
        await createAPI('perguntas', {
          pergunta,
          resposta,
          categorias: getIdsOptions(),
        });
        setCarregando(false);
        enqueueSnackbar('Categoria de pergunta criada com sucesso!', {
          variant: 'success',
        });
      } else {
        await updateAPI('perguntas', id, {
          pergunta,
          resposta,
          categorias: getIdsOptions(),
        });
        setCarregando(false);
        enqueueSnackbar('Categoria de pergunta atualizada com sucesso!', {
          variant: 'success',
        });
      }

      handleCloseDialog();
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  useImperativeHandle(ref, () => ({
    handleCreate() {
      reiniciar();
      setOpen(true);
    },
    handleEdit(id) {
      setCarregando(true);
      getDataResource(id);
      setId(id);
      setOpen(true);
    },
  }));

  function validatePergunta() {
    let error = '';
    if (!pergunta) error = 'Este campo é obrigatório';
    else if (pergunta.length < 5) {
      error = 'Número de caracteres menor que o permitido (mínimo 5)';
    }
    return error;
  }

  function validateResposta() {
    let error = '';
    if (!resposta) error = 'Este campo é obrigatório';
    else if (resposta.length < 5) {
      error = 'Número de caracteres menor que o permitido (mínimo 5)';
    }
    return error;
  }

  function getErros() {
    const errosOld = [''];
    errosOld[0] = validatePergunta();
    errosOld[1] = validateResposta();
    return errosOld;
  }

  const erros = getErros();

  function hasError() {
    for (let i = 0; i < erros.length; i += 1) {
      if (erros[i] !== '') return true;
    }
    return false;
  }

  const erroExistente = hasError();

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        classes={{ paper: classes.rootDialogo }}
        className={classes.rootDialogo}
        fullWidth
        maxWidth="sm"
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle
          id="form-dialog-title"
          onClose={handleCloseDialog}
          style={{ backgroundColor: '#009FD4', color: 'white' }}
        >
          {id < 0
            ? `Nova Categoria de pergunta`
            : `Editar Categoria de pergunta`}
        </DialogTitle>
        <DialogContent
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          {carregando ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div>
              <Box flex={1} mr="0.5em">
                <TextInput
                  name="pergunta"
                  handleEnter={() => {}}
                  label="Pergunta"
                  handleKey={() => {}}
                  value={pergunta}
                  onChange={(value) => setPergunta(value.target.value)}
                  error={erros[0] !== ''}
                  helperText={erros[0]}
                  fullWidth
                  autoFocus
                  multiline
                  variant="outlined"
                />
              </Box>
              <Box flex={1} mr="0.5em">
                <TextInput
                  name="resposta"
                  handleEnter={() => {}}
                  label="Resposta"
                  handleKey={() => {}}
                  value={resposta}
                  onChange={(value) => setResposta(value.target.value)}
                  error={erros[1] !== ''}
                  helperText={erros[1]}
                  fullWidth
                  multiline
                  variant="outlined"
                />
              </Box>
              <Box flex={1} mr="0.5em" mt="16px" mb="8px">
                <TagsInput
                  name="categorias"
                  handleEnter={() => {}}
                  label="Tags"
                  handleKey={() => {}}
                  fullWidth
                  options={categoriasOptions}
                  value={categorias}
                  onChange={setCategorias}
                />
              </Box>
            </div>
          )}
        </DialogContent>
        <DialogActions
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          <div className={classes.wrapper}>
            <Button
              onClick={handleSalvar}
              classes={{
                root: classes.btnAtions,
                disabled: classes.btnAtionsDisabled,
              }}
              disabled={erroExistente || carregando}
              variant="contained"
              color="primary"
            >
              Salvar
            </Button>
            {carregando && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default DialogoCategoriaTransacao;
